import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import * as orderActionTypes from '../../details/containers/details-constants';
import * as actionTypes from './task-list-constants';

export const taskList = handleActions(
  {
    [combineActions(
      actionTypes.GET_TASKLIST_REQUEST,
    )]: () => ({}),
    [orderActionTypes.GET_ORDER_DETAILS_REQUEST]: (state, { payload }) =>
      payload?.skipLoading ? state : {},
    [combineActions(
      orderActionTypes.GET_ORDER_DETAILS_SUCCESS,
      orderActionTypes.SAVE_ORDER_SUCCESS,
    )]: (state, { payload }) => payload.taskList,
    [actionTypes.GET_TASKLIST_SUCCESS]: (state, { payload }) => payload.taskList,
  },
  {},
);

export const isLoading = handleActions(
  {
    [actionTypes.GET_TASKLIST_REQUEST]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.GET_TASKLIST_SUCCESS,
      actionTypes.GET_TASKLIST_FAILURE,
    )]: () => false,
  },
  false,
);

export default combineReducers({
  taskList,
  isLoading,
});
